import { utils } from "@alife/cone-arms-core";
var checkWin = utils.checkWin, getXPath = utils.getXPath;
export var init = function() {
    var tables = {};
    var maxNodesCount = 0;
    var timer;
    var unbind = function() {
        clearInterval(timer);
    };
    if (checkWin()) {
        var changeHandle = function() {
            var _document_querySelectorAll;
            if (!checkWin()) return;
            var curNodesCount = ((_document_querySelectorAll = document.querySelectorAll("*")) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.length) || 0;
            if (curNodesCount > maxNodesCount) maxNodesCount = curNodesCount;
            var curTables = document.querySelectorAll('[data-name="CnTable"]');
            if (curTables && curTables.length > 0) curTables.forEach(function(table) {
                if (table) {
                    var _table_querySelectorAll;
                    var xpath = getXPath(table, 5);
                    if (!tables[xpath]) tables[xpath] = {
                        xpath: xpath,
                        columns: ((_table_querySelectorAll = table.querySelectorAll("thead>tr>th")) === null || _table_querySelectorAll === void 0 ? void 0 : _table_querySelectorAll.length) || 0
                    };
                    else {
                        var _table_querySelectorAll1;
                        var columns = ((_table_querySelectorAll1 = table.querySelectorAll("thead>tr>th")) === null || _table_querySelectorAll1 === void 0 ? void 0 : _table_querySelectorAll1.length) || 0;
                        if (columns > tables[xpath].columns) tables[xpath].columns = columns;
                    }
                }
            });
        };
        if (typeof MutationObserver !== "undefined") {
            var observerMutation = new MutationObserver(changeHandle);
            observerMutation.observe(document.documentElement, {
                childList: true,
                subtree: true
            });
            unbind = function() {
                observerMutation.disconnect();
            };
        } else timer = setInterval(changeHandle, 1000);
    }
    return {
        reset: function() {
            maxNodesCount = 0;
            tables = {};
        },
        unbind: unbind,
        getData: function() {
            var tableList = Object.keys(tables).map(function(key) {
                return tables[key];
            });
            return {
                maxNodesCount: maxNodesCount,
                tables: tableList,
                bigTableCount: tableList.filter(function(table) {
                    return table.columns > 10;
                }).length
            };
        }
    };
};
